import { INSAContacts } from "../types";
import CarrierContacts from "./CarrierContacts";
interface CarrierNSAContactProps {
  nsaContacts?: Array<INSAContacts>;
}
const defaultContact = [
  {
    parentRow: true,
    tableName: "nsaContacts",
  },
] as Array<INSAContacts>;
const CarrierNSAContact = ({
  nsaContacts = defaultContact,
}: CarrierNSAContactProps): JSX.Element => {
  return (
    <div className="mt-2 bg-white box-shadow rounded-lg h-full pb-4">
      <div className="px-3 py-2 text-primary font-bold text text-xs">
        NSA Contact
      </div>
      <CarrierContacts carrierContacts={nsaContacts} />
    </div>
  );
};

export default CarrierNSAContact;
